import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campus-list',
  templateUrl: './campus-list.component.html',
  styleUrls: ['./campus-list.component.scss']
})
export class CampusListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
